import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_drawerLayout/admin/notification/")({
  component: RouteComponent,
  beforeLoad: () => {
    return redirect({
      to: "/admin/notification/email",
      replace: true,
    });
  },
});

function RouteComponent() {
  return <></>;
}
